import { FC, SVGProps } from 'react';

export const FileIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns='http://www.w3.org/2000/svg' width='23' height='23' viewBox='0 0 23 23' fill='none' {...props}>
		<path
			d='M13.263 15.5338H8.18086C7.79123 15.5338 7.47501 15.2176 7.47501 14.828C7.47501 14.4383 7.79123 14.1221 8.18086 14.1221H13.263C13.6526 14.1221 13.9689 14.4383 13.9689 14.828C13.9689 15.2176 13.6526 15.5338 13.263 15.5338Z'
			fill='currentColor'
			fillOpacity='0.4'
		/>
		<path
			d='M8.17994 12.0027H11.3384C11.728 12.0027 12.0443 11.6865 12.0443 11.2969C12.0443 10.9072 11.728 10.591 11.3384 10.591H8.17994C7.79031 10.591 7.47409 10.9072 7.47409 11.2969C7.47409 11.6865 7.79031 12.0027 8.17994 12.0027Z'
			fill='currentColor'
			fillOpacity='0.4'
		/>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M13.314 2.26689H7.41142C5.09339 2.26689 3.165 4.14728 3.11041 6.48225V16.5496C3.05865 18.9241 4.94846 20.8986 7.32201 20.9523L14.9716 20.9513C17.3367 20.8553 19.1757 18.926 19.1587 16.5647V7.93819C19.1587 7.75655 19.0881 7.58056 18.962 7.44974L14.1951 2.48335C14.0615 2.345 13.878 2.26689 13.686 2.26689H13.5638C13.5233 2.25964 13.4815 2.25586 13.4389 2.25586C13.3963 2.25586 13.3546 2.25964 13.314 2.26689ZM16.9738 7.41707L14.1448 4.47019V5.69949C14.1448 6.64439 14.9137 7.41424 15.8577 7.41707H16.9738ZM12.7331 3.6786V5.69949C12.7331 7.41989 14.1335 8.82407 15.8558 8.82877H17.747V16.5703C17.7583 18.1703 16.5141 19.4756 14.9434 19.5406H7.35401C5.75784 19.5048 4.4873 18.1768 4.52212 16.5647V6.49919C4.55883 4.94161 5.85383 3.6786 7.4133 3.6786H12.7331Z'
			fill='currentColor'
			fillOpacity='0.4'
		/>
	</svg>
);
